import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/icons/logo-dark.svg";
import { ReactComponent as Menu } from "../assets/icons/menu.svg";
import { ReactComponent as Arrow } from "../assets/icons/arror-right.svg";
import Button from "../components/ui/button";
import SideMenu from "./SideMenu";

type PropType = {
  page: string;
  color: "white" | "off";
};

const Header = ({ page, color }: PropType) => {
  const navigate = useNavigate();
  const navigationLinks = [
    {
      page: "product",
      to: "/product",
      text: "product",
      subNav: [
        {
          to: "/money-transfer",
          text: "Send & Receive Money",
        },
        {
          to: "/virtual-card",
          text: "Virtual Dollar Card",
        },
        {
          to: "/virtual-wallet",
          text: "Virtual Wallet",
        },
        {
          to: "#",
          text: "Pay Bills",
        },
        // {
        //   to: "https://kudihero.com/",
        //   text: "Kudi Hero",
        // },

        // {
        //   to: "#",
        //   text: "Agency Program",
        // },
        // {
        //   to: "/business",
        //   text: "FX Kudi For Business",
        // },
      ],
    },
    {
      page: "company",
      to: "/about",
      text: "company",
    },
    {
      page: "blog",
      to: "https://fxkudiblog.com/",
      text: "blog",
    },
    {
      page: "contact",
      to: "/contact",
      text: "contact",
    },
  ];

  const [menuActive, setMenuActive] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      {menuActive && <SideMenu onClose={() => setMenuActive(false)} />}
      <div
        className={`flex fixed top-0 justify-between items-center py-5 md:py-3 px-4 md:px-16 w-full z-[8]  ${
          color === "white" ? "bg-white border-b " : "bg-[#FFFDF6]"
        } `}
      >
        <div className="flex justify-between items-center container mx-auto">
          <Link to="/">
            <img src={Logo} alt="FXKudi" className="w-24" />
          </Link>
          <div className="flex items-center gap-5">
            <div className="hidden lg:flex relative">
              {navigationLinks.map((item) => (
                <div
                  className="ml-6 text-[#231F20] capitalize font-medium"
                  key={item.to}
                >
                  {item.page === "blog" ? (
                    <a href={item.to} target="_blank" rel="noreferrer">
                      {item.text}
                    </a>
                  ) : (
                    <div
                      className={`cursor-pointer ${
                        page === item.page ? "text-transWhite7" : ""
                      }`}
                      // to={item.to}
                      onMouseEnter={() =>
                        item.text === "product" && setIsOpen(!isOpen)
                      }
                      // onMouseLeave={() =>
                      //   item.text === "product" && setIsOpen(false)
                      // }
                      onClick={() => {
                        item.text === "product"
                          ? setIsOpen(!isOpen)
                          : navigate(`${item.to}`);
                      }}
                    >
                      {item.text}
                    </div>
                  )}
                  {isOpen && item.subNav && (
                    <div
                      className="absolute top-10 flex flex-col gap-3 bg-white min-w-[300px] p-3 rounded-lg border border-primary"
                      onMouseLeave={() =>
                        item.text === "product" && setIsOpen(false)
                      }
                    >
                      {item.subNav.map((it) => (
                        <div className="text-sm font-normal">
                          {it.text === "Kudi Hero" ? (
                            <a
                              href={it.to}
                              target="_blank"
                              rel="noreferrer"
                              className="flex items-center justify-between"
                            >
                              {it.text}
                              <Arrow />
                            </a>
                          ) : (
                            <Link
                              to={it.to}
                              className="flex items-center justify-between"
                            >
                              {it.text}
                              <Arrow />
                            </Link>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
            <Menu
              className="block md:hidden"
              onClick={() => setMenuActive(true)}
            />
            <div className="hidden md:block">
              <Button
                backgroundColor="#C29500"
                label="Become an Agent"
                loading={false}
                onClick={() => {}}
                type="contained"
                color="white"
                rounded
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
